const benefits = [
  {
    icon: "ri-microscope-line",
    iconBg: "bg-teal-50",
    iconColor: "text-teal-600",
    title: "Detección Temprana",
    description:
      "Utilizamos tecnología de colposcopia digital de vanguardia para identificar lesiones en sus etapas más iniciales, cuando el tratamiento es más efectivo.",
  },
  {
    icon: "ri-shield-check-line",
    iconBg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    title: "Atención Especializada",
    description:
      "El Dr. Erick Tejada posee formación especializada en colposcopia y detección del VPH con protocolos médicos internacionales actualizados.",
  },
  {
    icon: "ri-heart-pulse-line",
    iconBg: "bg-rose-50",
    iconColor: "text-rose-500",
    title: "Procedimientos Seguros",
    description:
      "Ambiente clínico con las más altas normas de bioseguridad, garantizando procedimientos seguros y cómodos para cada paciente.",
  },
  {
    icon: "ri-user-heart-line",
    iconBg: "bg-amber-50",
    iconColor: "text-amber-600",
    title: "Cercanía y Confianza",
    description:
      "Atención personalizada con lenguaje claro, sin tecnicismos. Resolvemos todas tus dudas y te acompañamos en cada paso de tu salud.",
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span
            className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            ¿Por qué elegirnos?
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Tu salud femenina merece{" "}
            <span className="italic font-normal text-teal-600" style={{ fontFamily: "'Lora', serif" }}>
              lo mejor
            </span>
          </h2>
          <p
            className="text-slate-500 max-w-xl mx-auto text-sm md:text-base leading-relaxed"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            En la Clínica Dr. Erick Tejada combinamos experiencia médica, tecnología avanzada y atención humana para brindarte la mejor atención en colposcopia y ginecología en Panamá.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-white rounded-2xl p-6 md:p-7 border border-slate-100 hover:border-teal-200 transition-all hover:-translate-y-1 duration-300"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${b.iconBg} mb-4 md:mb-5`}>
                <i className={`${b.icon} ${b.iconColor} text-xl md:text-2xl`}></i>
              </div>
              <h3
                className="font-semibold text-slate-800 text-sm md:text-base mb-2 md:mb-3"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {b.title}
              </h3>
              <p
                className="text-slate-500 text-sm leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {b.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
